import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "monero",
  "use": "monero-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"monero\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.5 46C36.374 46 46 36.374 46 24.5S36.374 3 24.5 3 3 12.626 3 24.5 12.626 46 24.5 46zm0-40C34.718 6 43 14.282 43 24.5S34.718 43 24.5 43 6 34.718 6 24.5 14.282 6 24.5 6z\" /><path d=\"M15.843 23.76v11.037H6.58v-4h5.263V14.103l13.223 13.225 13.555-13.554v17.023h4.272v4h-8.272V23.43l-9.555 9.554-9.223-9.223z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol